export const onFileUploadAccepted = (
  setAcceptedFile: React.Dispatch<React.SetStateAction<File | undefined>>
) => {
  return (files: File[]) => {
    if (files.length) {
      setAcceptedFile(files[0]);
    }
  };
};
